import { z } from "zod";
import {
	richMenuDisplayPrioritySchema,
	richMenuTabGroupSchema,
} from "./richmenu.schemas";

/**
 * =============================================================================
 * POST /richmenu-tab-groups API SCHEMAS
 * =============================================================================
 */

/**
 * Standard API success response base structure
 */
export const ApiSuccessResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(true),
});

/**
 * Standard API error response base structure
 */
export const ApiErrorResponseBaseSchema = z.object({
	message: z.string(),
	success: z.literal(false),
	details: z.any().optional(),
});

/**
 * POST /richmenu-tab-groups - Request Body
 */
export const createRichMenuTabGroupMutationRequestSchema = z.object({
	name: z.coerce.string().describe("Name of the tab group"),
	displayPriority: richMenuDisplayPrioritySchema
		.describe("Display priority for the tab group")
		.optional(),
});

/**
 * @description Successfully created rich menu tab group
 */
export const createRichMenuTabGroup200Schema =
	ApiSuccessResponseBaseSchema.extend({
		data: richMenuTabGroupSchema,
	}).strict();

/**
 * @description Bad request
 */
export const createRichMenuTabGroup400Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

/**
 * @description Internal server error
 */
export const createRichMenuTabGroup500Schema = z.lazy(
	() => ApiErrorResponseBaseSchema,
);

// Convenience aliases
export const createRichMenuTabGroupMutationResponseSchema = z.lazy(
	() => createRichMenuTabGroup200Schema,
);
